import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import Button from "../../forms/Button/Button";
import { GET_STARTED } from "../../../routes/paths";
import bgImg from "../../../assets/images/products/grass/freshGrass_box.png";

import styles from "./styles.module.scss";
import { useLocalizedPath } from "../../../seo/useLocalizedPath";

const HomeSecondSection = () => {
  const navigate = useNavigate();
  const localizePath = useLocalizedPath();
  const { t } = useTranslation();

  return (
    <div className={styles.homeSecondSection}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.bgImgWrapper}>
            <img src={bgImg} alt="" />
          </div>
          <div className={styles.contentWrapper}>
            <h2>{t("dogPottyMadeEasy")}</h2>
            <p className="strong">{t("realSwitzerlandGrownGrass")}</p>
            <p>{t("pottyPadsForTraining")}</p>
            <p>{t("try4Sizes")}</p>
            <Button onClick={() => navigate(localizePath(GET_STARTED))}>
              {t("getStarted")}!
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSecondSection;
